import {
  ConfirmationModalOptions,
  openConfirmationModal,
} from './open-confirmation';

type AlertModalOptions = Omit<ConfirmationModalOptions, 'cancelLabel'>;

export const openAlertModal = ({ ...props }: AlertModalOptions) =>
  openConfirmationModal({
    submitLabel: 'OK',
    ...props,
    cancelLabel: null,
  });

export const waitForAlertModal = ({
  ...props
}: Omit<AlertModalOptions, 'onConfirm'>) =>
  new Promise<void>((resolve) =>
    openAlertModal({
      ...props,
      onConfirm: () => resolve(),
    })
  );
